import { TAG_CONDITION_FORCE_DOUBLE_SIDED } from "building-types/buildingGeomTag/buildingGeomTagTypes";
import type { Face } from "geom/brep";
import { faceCopy, faceReverse, tagFace } from "geom/brep";

export function addDoubleSidedFace(face: Face, faces: Face[] = []) {
  faces.push(face);
  faces.push(tagFace(faceReverse(faceCopy(face)), TAG_CONDITION_FORCE_DOUBLE_SIDED));
  return faces;
}
